// extracted by mini-css-extract-plugin
export var standaloneTable = "_ey-0";
export var standaloneTableWithBodyFill = "_ey-1";
export var withExtraHeader = "_ey-2";